import './Colophon.css'

export default function Colophon() {
    return (
        <footer className='container colophon'>
            <div className='colophon-bar'>
                <span>Victoria López</span>
                <span>Printed with HTML, CSS &amp; JavaScript</span>
            </div>
        </footer>
    )
}
